import { ProjectOverviewPage } from "@/components/projects/project-overview";
import { createFileRoute, useLoaderData } from "@tanstack/react-router";

/**
 * `/{group}/{project}` overview — the default sub-route of the
 * GitLab-native project layout. Renders the same overview body as
 * the internal `/projects/{slug}` route, fed by the parent
 * layout's loader.
 */
export const Route = createFileRoute("/_app/$group/$project/")({
  component: GitlabNativeProjectOverview,
});

function GitlabNativeProjectOverview() {
  return <ProjectOverviewPage data={useLoaderData({ from: "/_app/$group/$project" })} />;
}
